import { ThemeStyle } from '../enums/Enum';

const setSkinType = (ApexChat, skinThemeStyle) => {
    const themes = {
        1: 'DefaultTheme',
        2: 'RdTheme',
        3: 'RdPlusTheme'
    };
    return {
        ...ApexChat,
        Theme: themes[skinThemeStyle],
        IsRoundedDynamicPlusTheme: skinThemeStyle === ThemeStyle.Rounded_Dynamic_Plus
    };
};
export default setSkinType;
